import { IErrorPayload } from "@/fe-core/meta/interfaces/root";
import {
  ClaimLevelupAwardRequestPayload,
  LevelupDetailsItem,
} from "@/fe-core/meta/interfaces/user/levelupDetails";
import { userActionTypes } from "@/fe-core/meta/types/user";
import {
  ClaimLevelupAwardFailureAction,
  ClaimLevelupAwardRequestAction,
  ClaimLevelupAwardSuccessAction,
  ClearRedeemLevelUpMessageAction,
  GetLevelupDetailsFailureAction,
  GetLevelupDetailsRequestAction,
  GetLevelupDetailsSuccessAction,
} from "@/fe-core/meta/types/user/levelupDetails";

export const getLevelupDetailsRequest = (): GetLevelupDetailsRequestAction => ({
  type: userActionTypes.GET_LEVEL_UP_DETAILS_REQUEST,
});

export const getLevelupDetailsSuccess = (
  payload: LevelupDetailsItem[]
): GetLevelupDetailsSuccessAction => ({
  type: userActionTypes.GET_LEVEL_UP_DETAILS_SUCCESS,
  payload,
});

export const getLevelupDetailsFailure = (
  payload: IErrorPayload
): GetLevelupDetailsFailureAction => ({
  type: userActionTypes.GET_LEVEL_UP_DETAILS_FAILURE,
  payload,
});

export const claimLevelupAwardRequest = (
  payload: ClaimLevelupAwardRequestPayload
): ClaimLevelupAwardRequestAction => ({
  type: userActionTypes.CLAIM_LEVEL_UP_AWARD_REQUEST,
  payload,
});

export const claimLevelupAwardSuccess = (
  payload: LevelupDetailsItem[]
): ClaimLevelupAwardSuccessAction => ({
  type: userActionTypes.CLAIM_LEVEL_UP_AWARD_SUCCESS,
  payload,
});

export const claimLevelupAwardFailure = (
  payload: IErrorPayload
): ClaimLevelupAwardFailureAction => ({
  type: userActionTypes.CLAIM_LEVEL_UP_AWARD_FAILURE,
  payload,
});

export const clearRedeemLevelUpMessage =
  (): ClearRedeemLevelUpMessageAction => ({
    type: userActionTypes.CLEAR_REDEEM_LEVEL_UP_MESSAGE,
  });
